export default __webpack_public_path__ + "static/media/loading.4499b184.gif";